import * as types from "../../_constants/types";

export default (state = {}, action) => {
    switch (action.type) {
        case types.SEARCH_RESULT_LOAD:
            return Object.assign({}, action.results);

        case types.RESET:
        case types.SEARCH_RESULT_RESET:
            return {};

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/_reducers/Search/_data.js